import Vue from "vue";
import Component from "vue-class-component";

@Component()
export default class Translations extends Vue {
  get translations() {
    return this.$store.state.translationsStore.currentLang;
  }
}
